module.exports = __webpack_public_path__ + "media/icons/desktop-smartphone-gray-e31192fa.png";